export default {
  LINKED_INVESTOR_GOAL_STATE_MANAGER: Symbol.for('LINKED_INVESTOR_GOAL_STATE_MANAGER'),
  LINKED_GOAL_STATE_MANAGER_SERVICE: Symbol.for('LINKED_GOAL_STATE_MANAGER_SERVICE'),
};
